import { render } from 'preact';
import { VitrinApp } from '../ilan-vitrin/VitrinApp.jsx';
import '../ilan-vitrin/vitrin.css';

const el = document.getElementById('pp-ilan-vitrin-root');
if (el) {
  render(<VitrinApp />, el);
}
